import axios from 'axios';
import { SSOClient } from 'interfaces/SSOClient';

const URL = process.env.REACT_APP_API_URL_AUTH;

export const getSSOClientsPublic = (): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get(`${URL}/sso/clients/`)
            .then(resp => resolve(resp))
            .catch(err => reject(err));
    });
};

export const getSSOClients = (page = 1): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get(`${URL}/sso-clients/?page=${page}`)
            .then(resp => resolve(resp))
            .catch(err => reject(err));
    });
};

export const getSSOClientById = (id: string): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get(`${URL}/sso-clients/${id}/`)
            .then(resp => resolve(resp))
            .catch(err => reject(err));
    });
};

export const createSSOClient = (payload: SSOClient): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post(`${URL}/sso-clients/`, payload)
            .then(resp => resolve(resp))
            .catch(err => reject(err));
    });
};

export const editSSOClient = (id: string, payload: SSOClient): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.patch(`${URL}/sso-clients/${id}/`, payload)
            .then(resp => resolve(resp))
            .catch(err => reject(err));
    });
};

export const deleteSSOClient = (id: string): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete(`${URL}/sso-clients/${id}/`)
            .then(resp => resolve(resp))
            .catch(err => reject(err));
    });
};
